import { Form, Formik } from 'formik'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import styled from 'styled-components'
import Button from '../../../components/buttons/buttons.component'
import { CheckboxToggleInput } from '../../../components/form-components/inputs.component'
import { PRIMARY_COLOR } from '../../../styles/colors.style'
import { Link } from 'react-router-dom'
import { routes } from '../../../constants/routes.constants'

const StyledInputContainer = styled.div``

const StyledButtonContainer = styled.div`
	margin-top: 5rem;
	display: flex;
	justify-content: flex-end;
`

export default class NewsletterForm extends Component {
	constructor(props) {
		super(props)
		this.newsletterRef = React.createRef()
	}

	render() {
		const { onSubmit, onClick, onBack, isDisabled } = this.props
		return (
			<Formik
				initialValues={{
					newsletter: true
				}}
				onSubmit={onSubmit}
				render={props => (
					<Form noValidate>
						<StyledInputContainer>
							<p>
								Aceito receber informações, dicas, pesquisa de
								satisfação e promoções do Muviflex por e-mail, torpedo,
								ligação telefônica e/ou whatsApp.
							</p>
							<div
								style={{
									display: 'flex',
									alignItems: 'center'
								}}>
								<CheckboxToggleInput
									elementRef={this.newsletterRef}
									id="newsletter"
									{...props}
								/>
								<p style={{ paddingLeft: '1rem' }}>
									{props.values.newsletter ? (
										<span
											style={{
												color: PRIMARY_COLOR
											}}>
											Sim
										</span>
									) : (
										'Não'
									)}
								</p>
							</div>
						</StyledInputContainer>
						<StyledInputContainer>
							<p style={{ marginTop: '4.5rem' }}>
								Ao finalizar o cadastro declaro que li e concordo com os{' '}
								<Link
									className="gray"
									to={routes.REGULAMENTO}
									target="_blank">
									termos e condições de uso
								</Link>{' '}
								e com o{' '}
								<Link
									className="gray"
									to={routes.POLITICAS}
									target="_blank">
									termo de privacidade
								</Link>{' '}
								do Muviflex.
							</p>
						</StyledInputContainer>
						<StyledButtonContainer>
							<Button
								link
								type="button"
								onClick={() => {
									onBack && onBack()
								}}>
								Anterior
							</Button>
							<Button
								disabled={isDisabled}
								primary
								type="submit"
								onClick={() => {
									onClick && onClick(props.isValid)
								}}>
								Finalizar
							</Button>
						</StyledButtonContainer>
					</Form>
				)}
			/>
		)
	}
}

NewsletterForm.propTypes = {
	onSubmit: PropTypes.func.isRequired,
	onClick: PropTypes.func
}
